import { Button } from '@plato/ui-legacy/components/ui/button';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';
import { cn } from '@plato/ui/util/classes';
import { SearchIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { isMacOs, isWindows } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { getShortcutKey } from '../utils/get-shortcut-key.ts';
import { useGlobalSearch } from './global-search-bar-provider.tsx';

type Props = {
    showFullInput?: boolean;
    showShortcutKey?: boolean;
    className?: string;
} & PropsWithChildren;

function GlobalSearchBar({ showFullInput = true, showShortcutKey = true, className = '' }: Props) {
    const { t } = useTranslation();
    const locale = useResolvedLocale();

    const { openSearch, open } = useGlobalSearch();

    const shortcutKey = getShortcutKey({ isMacOs, isWindows, locale });

    return (
        <div className={cn(showFullInput ? 'w-full' : '', className)}>
            {showFullInput ? (
                <Button
                    className="w-full bg-white border"
                    variant="ghost"
                    selected={open}
                    onClick={() => {
                        openSearch();
                    }}
                >
                    <SearchIcon className="h-4 w-4" />
                    <span className="mr-auto">{t('search')}</span>
                    {showShortcutKey && <span className="rounded-md border px-1">{shortcutKey}</span>}
                </Button>
            ) : (
                <Button
                    size="icon-s"
                    variant="ghost"
                    selected={open}
                    onClick={() => {
                        openSearch();
                    }}
                >
                    <SearchIcon className="flex h-4 w-4 shrink-0" />
                </Button>
            )}
        </div>
    );
}

export { GlobalSearchBar };
